module.exports = __webpack_public_path__ + "static/3c040b41-200c-4a75-ad89-5717ea1cd7c9-b9d9139c61d8eb6946f7c315b525d0af.jpg";